import React from 'react';
import { Title } from '../../components/title';
import { createCn } from 'bem-react-classname';
import './style.css';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

const cn = createCn('rules');

export const Documents = () => {
    const { i18n } = useTranslation();
    const title = i18n.language === 'en' ? 'Subscription Form' : 'Modulo di iscrizione';
    const delega = i18n.language === 'en' ? '/docs/Registration_Form_2026_2_ENG.docx' : '/docs/Registration_Form_2026_2_IT.docx';

    return (
        <div className={ cn() }>
            <Title title={ title }/>
            <div>{title} Pole Revolution 2026 - <a href={ delega } target={ '_blank' } download={ title + ' Pole Revolution 2026' }>download</a><br/><br/></div>
        </div>
    );
};
